import React from 'react';
import parse from "html-react-parser";
function Footer() {
    return (
        <div id="amex-footer">
            <div className="footer">
                <footer data-module-name="axp-footer" className=" dlsWhiteBg">
                    <div className="container width-full">
                        <div className="row">
                            <div className="col-md-12 pad-3-t ">
                                <span className="dls-logo-line-sm"><img src="https://www.aexp-static.com/cdaas/one/statics/axp-static-assets/2.14.3/package/dist/img/logos/dls-logo-line.svg" alt="American Express" /></span>
                            </div>
                        </div>
                        <div className=" row">
                            <div className="col-md-12 pad-3-t">
                                <div className="list list-links ">
                                    <ul className="list-links-inline-separator">
                                        <li><a className="text-wrap" href="https://www.americanexpress.com/india/legal/rulesreg.shtml?inav=in_sitefooter_bottom_website_rules_and_regulations" rel="nofollow" target="" title="Website Rules and Regulations" tracking="in_sitefooter_bottom_website_rules_and_regulations">Website Rules and Regulations</a></li>
                                        <li><a className="text-wrap" href="https://www.americanexpress.com/india/legal/trademarks.shtml?inav=in_sitefooter_bottom_trademarks" rel="" target="" title="Trademarks" tracking="in_sitefooter_bottom_trademarks">Trademarks</a></li>
                                        <li><a className="text-wrap" href="https://www.americanexpress.com/in/privacy-statement.html?inav=in_sitefooter_bottom_privacy_centre" rel="" target="" title="Privacy Centre" tracking="in_sitefooter_bottom_privacy_centre">Privacy Centre</a></li>
                                        <li><a className="text-wrap" href="https://www.americanexpress.com/in/sitemap/personal.html?inav=in_sitefooter_bottom_sitemap_personal" rel="" target="" title="Sitemap" tracking="in_sitefooter_bottom_sitemap_personal">Sitemap</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 pad-1-t ">
                                <p> {parse('Copyright © 2021 American Express Company | American Express Banking Corp.')} </p>
                            </div>
                        </div>
                    </div>
                </footer>
            </div>
        </div>
    );
}
export default Footer;